import { z } from 'zod';
import { type TranslationKey } from '@/i18n/translation-key.tsx';

export const updateUserContributorProfileSchemaFactory = (t: (key: TranslationKey) => string) => {
  return z.object({
    displayName: z.string().min(2, t('contributor.validation.nameMinLength')),
    title: z.string().optional(),
    organization: z.string().optional(),
    bio: z.string().optional(),
    contactEmail: z.string().email().optional(),
    contactPhone: z.string().optional(),
  });
};
